import { EMOTION_CACHE_KEY } from './emotion-cache-key.mjs';
import { markIslandSsrEmotionStyleTags } from './wrap-island-emotion-sheet-flush.js';

const ISLAND_EMOTION_STYLE_SELECTOR = `style[data-emotion^="${EMOTION_CACHE_KEY}"]`;

/**
 * @param {import('@emotion/cache').EmotionCache} cache
 * @param {NodeListOf<HTMLStyleElement> | HTMLStyleElement[]} styleElements
 */
function registerIslandEmotionStyleHashes(cache, styleElements) {
	for (const styleElement of styleElements) {
		const dataEmotion = styleElement.getAttribute('data-emotion');
		if (dataEmotion === null) {
			continue;
		}

		const emotionParts = dataEmotion.split(' ');
		for (let partIndex = 1; partIndex < emotionParts.length; partIndex += 1) {
			const emotionHash = emotionParts[partIndex].trim();
			if (emotionHash !== '') {
				cache.inserted[emotionHash] = true;
			}
		}
	}
}

/**
 * Emotion's default cache hydration matches `data-emotion="rp-island …"` but batch SSR also emits
 * hoisted `rp-island-global …` tags; register every hash and mark SSR styles for flush preservation.
 * Component `rp-island …` tags are already registered and hydrated by createCache.
 * @param {import('@emotion/cache').EmotionCache} cache
 */
export function hydrateIslandEmotionCacheFromDocument(cache) {
	if (typeof document === 'undefined') {
		return;
	}

	const styleElements = document.querySelectorAll(ISLAND_EMOTION_STYLE_SELECTOR);
	if (styleElements.length === 0) {
		return;
	}

	markIslandSsrEmotionStyleTags(styleElements);
	registerIslandEmotionStyleHashes(cache, styleElements);
}
